import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

const SHOW_MORE_CHARACTER_COUNT = 200
import styles from './product-description.module.scss'

export const getProductDescription = (
  description: string,
  showReadMore: boolean | undefined,
  showNewPdpDesignV2?: boolean,
) => {
  if (showReadMore && !showNewPdpDesignV2) {
    // Remove all the HTML elements
    const _description = description.replace(/<[^>]*>/g, '')

    if (_description.length > SHOW_MORE_CHARACTER_COUNT) {
      return `<p>${_description.slice(0, SHOW_MORE_CHARACTER_COUNT).trim()}<span data-readmore='true' class="${styles.readMore}">Read More</span></p>`
    }
  }

  return (
    getSanitizedHtml(description) +
    (showNewPdpDesignV2 ? '' : `<span data-readmore='false' class="${styles.readLess}"> Read Less</span>`)
  )
}
